import { API } from '../../utils';
import { IParams } from '../types';
import { GW_SERVICES_PREFIXES } from 'constants/gateway';

const { C300 } = GW_SERVICES_PREFIXES;

export const SendTelegramMessage = (data: IParams) =>
  API.gatewayPost(`/${C300}/tg_bot/notification/`, data);
